import React from 'react';
import css from './metricCards.css';
import metricCardsCss from './metricCard.css';
import { METRIC_CARDS_ORDER, METRICS_CARDS_DATA } from './consts';
import MetricCardsEmptyStateInner from './metricCardsEmptyStateInner';

function MetricCardsEmptyState() {
    return (
        <div className={css.metricCardsContainer}>
            {METRIC_CARDS_ORDER.map(key => {
                const { displayName, cohortPeriod } = METRICS_CARDS_DATA[key];
                const nameToDisplay = cohortPeriod ? `${displayName} ${cohortPeriod}` : displayName;
                return (
                    <div className={metricCardsCss.metricCard} key={displayName}>
                        <div className={metricCardsCss.metricName}>{nameToDisplay}</div>
                        <MetricCardsEmptyStateInner />
                    </div>
                );
            })}
        </div>
    );
}

export default MetricCardsEmptyState;
